import React, { useEffect, useState } from "react";
import { getFormmatedDate, getProperValueFromPoint } from "../../utils/helper";
import "./styles/TestResultHistory.css";

const TestResultHistory = ({ datePointsTable }: any) => {
  const [testResultDates, setTestResultDates] = useState<string[]>([]);
  const [testResultValues, setTestResultValues] = useState<number[]>([]);
  const [reversedDatePointsTable, setReversedDatePointsTable] = useState<any[]>([]);

  useEffect(() => {
    setReversedDatePointsTable(datePointsTable.slice().reverse());
  }, [datePointsTable]);

  useEffect(() => {
    console.log('datePointsTable: ', datePointsTable)
  }, [datePointsTable])

  useEffect(() => {
    console.log('reversedDatePointsTable: ', reversedDatePointsTable)
  }, [reversedDatePointsTable])

  useEffect(() => {
    const _dates: string[] = [];
    const _values: number[] = [];
    reversedDatePointsTable.forEach((_item) => {
      // console.log('typeof point: ', typeof _item.point, _item.point)
      _dates.push(getFormmatedDate(_item.date));
      _values.push(_item.point === '-' ? _item.point : parseFloat(_item.point));
    });
    setTestResultDates(_dates);
    setTestResultValues(_values);
  }, [reversedDatePointsTable]);

  const getFormattedTestValue = (_value: any) => {
    console.log('_value: ', _value)
    return <span>
      {
        getProperValueFromPoint(_value)
      }
    </span>
  }

  return (
    <div className="test-result-history">
      <div className="box patient-history-box">
        <div className="box-header">
          <span>History of test results</span>
          <div className="bottom-line"></div>
        </div>
        <div className="box-content">
          <div className="divtum-unit">
            <span className="part-1">DiviTum Units of Activity (DuA)</span>
            <span className="part-2">Reference range: {'<'} 250 DuA</span>
          </div>
          <div className="test-result-history-data">
            <div className="items-column">
              <div className="each-test">
                <div
                  className="most-recent-value"
                  style={{ display: testResultDates?.[0] ? 'flex' : 'none' }}
                >
                  <div className="test-date">{testResultDates[0]}</div>
                  <div className="test-value">
                    {getFormattedTestValue(testResultValues[0])}
                  </div>
                </div>
              </div>
              <div className="each-test">
                <div className="test-date">{testResultDates[1]}</div>
                <div className="test-value">
                  {getFormattedTestValue(testResultValues[1])}
                </div>
              </div>
              <div className="each-test">
                <div className="test-date">{testResultDates[2]}</div>
                <div className="test-value">
                  {getFormattedTestValue(testResultValues[2])}
                </div>
              </div>
              <div className="each-test">
                <div className="test-date">{testResultDates[3]}</div>
                <div className="test-value">
                  {getFormattedTestValue(testResultValues[3])}
                </div>
              </div>
            </div>
            <div className="items-column">
              <div className="each-test">
                <div className="test-date">{testResultDates[4]}</div>
                <div className="test-value">
                  {getFormattedTestValue(testResultValues[4])}
                </div>
              </div>
              <div className="each-test">
                <div className="test-date">{testResultDates[5]}</div>
                <div className="test-value">
                  {getFormattedTestValue(testResultValues[5])}
                </div>
              </div>
              <div className="each-test">
                <div className="test-date">{testResultDates[6]}</div>
                <div className="test-value">
                  {getFormattedTestValue(testResultValues[6])}
                </div>
              </div>
              <div className="each-test">
                <div className="test-date">{testResultDates[7]}</div>
                <div className="test-value">
                  {getFormattedTestValue(testResultValues[7])}
                </div>
              </div>

            </div>
            <div className="items-column">
              <div className="each-test">
                <div className="test-date">{testResultDates[8]}</div>
                <div className="test-value">
                  {getFormattedTestValue(testResultValues[8])}
                </div>
              </div>
              <div className="each-test">
                <div className="test-date">{testResultDates[9]}</div>
                <div className="test-value">
                  {getFormattedTestValue(testResultValues[9])}
                </div>
              </div>
              <div className="each-test">
                <div className="test-date">{testResultDates[10]}</div>
                <div className="test-value">
                  {getFormattedTestValue(testResultValues[10])}
                </div>
              </div>
              <div className="each-test">
                <div className="test-date">{testResultDates[11]}</div>
                <div className="test-value">
                  {getFormattedTestValue(testResultValues[11])}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestResultHistory;
